<template>
  <zj-layout-container>
    <zj-layout-header>
      <div class="listtitle">门禁设备</div>
      <el-divider></el-divider>
    </zj-layout-header>
    <zj-layout-main>
      <div class="zj-layout-main-content bgcolor scrollable">
        <div class="zj-table-container">
          <el-table
            v-loading="searching"
            element-loading-text="加载中..."
            :data="tableData"
            ref="multipleTable"
            border
            style="width: 100%"
            fixed
          >
            <el-table-column
              type="index"
              label="序号"
              width="80"
              align="center"
            ></el-table-column>
            <el-table-column
              prop="equipmentName"
              label="设备名称"
            ></el-table-column>
            <el-table-column
              prop="categoryCodeTranslated"
              label="设备类型"
            ></el-table-column>
            <el-table-column
              prop="areaCodeTranslated"
              label="区域"
            ></el-table-column>
            <el-table-column
              prop="equipmentLocation"
              label="安装位置"
            ></el-table-column>
            <el-table-column
              prop="onlineStatus"
              label="状态"
              width="100"
              align="center"
            >
              <template slot-scope="scope">
                <span v-if="scope.row.onlineStatus === '1'" style="color: #67C23A">在线</span>
                <span v-else style="color: #F56C6C">离线</span>
              </template>
            </el-table-column>
            <el-table-column
              prop="longitude"
              label="经度"
              width="140"
            ></el-table-column>
            <el-table-column
              prop="latitude"
              label="纬度"
              width="140"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </zj-layout-main>
    <zj-layout-footer>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        background
        :total="total"
      ></el-pagination>
    </zj-layout-footer>
  </zj-layout-container>
</template>
<script>
import { listExtEquipment } from "@/api/src/equipment";

export default {
  name: "DoorEquipView",
  controller: "UI",
  action: "doorEquipView",
  data() {
    return {
      searching: false,
      currentPage: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
    };
  },
  mounted: function () {
    this.search();
  },
  methods: {
    errmsg(msg) {
      this.$message({
        showClose: true,
        message: msg || "",
        type: "error",
        customClass: "zj-login-msgbox",
      });
    },
    search() {
      this.searching = true;
      let data = {
        categoryCode: "door",
        page: this.currentPage,
        size: this.pageSize,
      };
      listExtEquipment(data)
        .then((r) => {
          this.searching = false;
          this.tableData = r.rows;
          this.total = r.total;
        })
        .catch((e) => {
          console.log(e);
          this.searching = false;
          this.errmsg("服务异常，请联系管理员！");
        });
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
  },
};
</script>
